import { useCallback, useEffect, useState } from "react";
import { fetchPermissions, getPermissionErrorMessage } from "@/features/permission/services/permissionService";
const usePermissions = (options = {}) => {
    const [permissions, setPermissions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const loadPermissions = useCallback(async () => {
        setLoading(true);
        try {
            const result = await fetchPermissions({ all: options.fetchAll ?? true });
            setPermissions(result);
            setError(null);
        }
        catch (apiError) {
            setError(getPermissionErrorMessage(apiError));
        }
        finally {
            setLoading(false);
        }
    }, [options.fetchAll]);
    useEffect(() => {
        void loadPermissions();
    }, [loadPermissions]);
    return { permissions, loading, error, refetchPermissions: loadPermissions };
};
export default usePermissions;
